/** What each role is called on screen. */
export const ROLE_LABEL: Record<string, string> = {
  customer: 'Customer',
  contractor: 'Contractor',
  client: 'Client',
  referrer: 'OT / rehab',
};

const icon = {
  width: 13,
  height: 13,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
  'aria-hidden': true,
  focusable: false,
};

/** One small drawing per role, so a role reads at a glance and not only by its colour. */
const ICONS: Record<string, () => React.JSX.Element> = {
  // The person the work is done for: their home.
  customer: () => (
    <svg {...icon}>
      <path d="M4 11l8-6.5 8 6.5" />
      <path d="M6.5 9.5V19h11V9.5" />
    </svg>
  ),
  // Whoever does the work.
  contractor: () => (
    <svg {...icon}>
      <circle cx="12" cy="8" r="3.5" />
      <path d="M5 20c0-3.6 3.1-6 7-6s7 2.4 7 6" />
    </svg>
  ),
  // Whoever pays: an organisation.
  client: () => (
    <svg {...icon}>
      <rect x="5" y="3.5" width="14" height="17" rx="1.5" />
      <path d="M9 8h2M13 8h2M9 12h2M13 12h2M10.5 20.5v-4h3v4" />
    </svg>
  ),
  // Whoever sent the work in.
  referrer: () => (
    <svg {...icon}>
      <path d="M5 12h12M13 7l5 5-5 5" />
    </svg>
  ),
};

/** A contact's role, with its own icon and colour. */
export function RolePill(props: { role: string }) {
  const Icon = ICONS[props.role];
  return (
    <span className={`pill role role-${props.role}`}>
      {Icon && <Icon />}
      {ROLE_LABEL[props.role] ?? props.role}
    </span>
  );
}
